import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import PositionAdd from "@/views/MGT/position/components/position-add.vue";
import PositionDetail from "@/views/MGT/position/components/position-detail.vue";
import { tagListNoPage, deleteTagById } from "@/service/structure.js";
import _ from "lodash";
export default {
  name: "position-cluster",
  components: {
    PositionAdd,
    PositionDetail
  },
  data() {
    return {
      position: {
        visible: false,
        row: {},
        edit: false
      },
      positionDetail: {
        visible: false,
        row: {}
      },
      loading: false,
      searchValue: "",
      debouncedSearch: _.debounce(this.onSearch, 500),
      checkeditem: {},
      list: []
    };
  },
  computed: {
    _searchPlaceholder() {
      // 使用简单变量作为 gc-i18n 的插值参数，避免复杂表达式被当成占位符名称。
      const tagName = this.checkeditem.tagName || $t("g6mu2", "岗位");
      return $t("xvda89k", "\u67E5\u201C${tagName}\u201D\u4E0B\u7684\u6210\u5458/\u90E8\u95E8", {
        "tagName": tagName
      });
    },
    isAdmin() {
      return this.$store.state.user.userInfo.isAdmin === "T";
    }
  },
  async mounted() {
    await this.getList();
    if (this.list.length > 0) {
      this.onChange(this.list[0]);
    }
  },
  methods: {
    async getList() {
      this.loading = true;
      const {
        data
      } = await tagListNoPage();
      this.loading = false;
      if (data && data.result === 0) {
        this.list = data.retVal;
        if (this.list.length === 0) {
          this.searchValue = "";
          this.checkeditem = {};
        }
      }
    },
    onChange(item = {}) {
      this.checkeditem = item;
      this.$emit("onChange", item);
    },
    onDelete(item) {
      this.$Modal.confirm({
        // lg: 删除
        title: $t("eslg2", "删除"),
        loading: true,
        // lg: 确认删除
        content: `${$t('8ddcgw5', '确认删除：')}${item.tagName}？`,
        onOk: async () => {
          const params = {
            id: item.id
          };
          const {
            data
          } = await deleteTagById(params);
          if (data && data.result === 0) {
            // lg: 删除成功
            this.$Message.success($t("azeh8z4", "删除成功"));
            await this.getList();
            this.onChange(this.list[0]);
          }
          this.$Modal.remove();
        }
      });
    },
    onAdd() {
      this.position.edit = false;
      this.position.visible = true;
    },
    onEdit(item) {
      this.position.edit = true;
      this.position.row = item;
      this.position.visible = true;
    },
    onDetail(item) {
      this.positionDetail.visible = true;
      this.positionDetail.row = item;
    },
    async onSuccess() {
      await this.getList();
      if (this.checkeditem.tagId) {
        let find = this.list.find(v => v.tagId === this.checkeditem.tagId);
        if (find) {
          this.onChange(find);
        }
      } else {
        if (this.list.length > 0) {
          this.onChange(this.list[0]);
        }
      }
    },
    onChangeSearch() {
      // 触发防抖函数
      this.debouncedSearch();
    },
    onSearch() {
      // 这里放置实际的搜索逻辑
      this.$emit("onSearch", this.searchValue);
      // 例如调用API或其他操作
    }
  }
};